import { useCallback } from 'react';
import { PostHelpCenterEvent } from '@/apis/helpCenterAPI';
import { useToken } from '@/common/helper';
import type { HelpEventPayload } from '../../types';

// PRD telemetry. Fire and forget: analytics never blocks or breaks the UI, and
// a rejected event (400) is not retried.
export const useHelpEvent = () => {
  const { token } = useToken();

  return useCallback(
    (payload: HelpEventPayload) => {
      try {
        PostHelpCenterEvent(token, payload).catch(() => {});
      } catch {
        // Never let analytics affect the UI.
      }
    },
    [token]
  );
};

export default useHelpEvent;
